<template>
  <exception-page>
    <span>{{ message }}</span>
  </exception-page>
</template>

<script>
import exceptionPage from '../../templates/exception-page'
import * as errorMessages from '../../../error-messages'

export default {
  components: {
    exceptionPage
  },
  data () {
    return {
      message: errorMessages.WHOOPS
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/exceptions/whoops.vue